import {Injectable, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {BaseService} from '../../services/base.service';

@Injectable()
export class TaskTypeService extends BaseService implements OnInit {

    constructor(public http: HttpClient) {
        super('task-type', http);
    }

    ngOnInit(): void {
    }
}